// Per-step answered/total counts for the left-rail "X/Y" badge (adapted from
// Recover Configure).

import SECTION_SCHEMA, { SECTION_KEYS } from "../../constants/steps"
import { visibleQuestions } from "./showIf"

const getDeep = (obj, path) => {
  if (!path || !obj) return undefined
  return path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj)
}

const isAnswered = (value, q) => {
  const type = q?.type
  if (value === null || value === undefined) return false
  if (type === "text-multi") {
    if (Array.isArray(value)) return value.length > 0
    return typeof value === "string" && value.trim() !== ""
  }
  if (type === "upload") return !!(value && (value.s3_key || value.url))
  if (type === "phone") return !!(value && value.number)
  if (type === "textarea") {
    // §11.6: n counts non-empty fields regardless of validity - no minimum here.
    return typeof value === "string" && value.trim() !== ""
  }
  if (typeof value === "string") return value.trim() !== ""
  return true
}

// Checkboxes are excluded from the progress badge - toggling one doesn't answer
// anything on its own; the fields it reveals via `showIf` are what count.
export const sectionAnswerCount = (sectionKey, buildingBlocks) => {
  const schema = visibleQuestions(SECTION_SCHEMA[sectionKey] || [], buildingBlocks).filter(
    (q) => q.type !== "checkbox"
  )
  const sectionState = buildingBlocks?.[sectionKey] ?? {}
  const answered = schema.filter((q) => isAnswered(getDeep(sectionState, q.key), q)).length
  return { answered, total: schema.length }
}

export const allSectionCounts = (buildingBlocks) => {
  const out = {}
  for (const key of SECTION_KEYS) out[key] = sectionAnswerCount(key, buildingBlocks)
  return out
}
